import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import type {TableConfiguration} from 'schema/table/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import type {UpdateLogRow} from 'schemas/schemas';

dayjs.extend(localizedFormat);

export const updateLogTableConfig: TableConfiguration<UpdateLogRow> = {
  ...defaultTableConfig,
  disableSorting: true,
  partValueRenderers: {
    created: ({value}) => {
      return value && dayjs(value as string | number).isValid()
        ? dayjs(value as string | number).format('L LT')
        : null;
    },
  },
};
